<template>
  <div>
    <my-header
      :page_name="$t('navigation.headerTitles.users')"
      show_usermenu
    ></my-header>
    <reference-grid
      :gridData="getUsersTableArray"
      :columns="columnDefs"
      gridType="user"
      @deleteClicked="deleteClick"
    ></reference-grid>
  </div>
</template>

<script>
import Header from "../../components/reusable/header/Header";
import ReferenceGrid from "../../components/reference/ReferenceGrid";
import { mapGetters } from "vuex";
import i18n from "@/locales";
export default {
  data() {
    return {
      columnDefs: [],
    };
  },
  methods: {
    deleteClick({currentId, title}) {
      console.log(currentId);
      if(currentId === "0" || currentId === "1"){
        this.$message(this.$t('users.errorYouCantDeleteDeveloper'));
        return;
      }
      this.$confirm(
        `${this.$t('users.actionDeleteThisUser')}: ${title}. ${this.$t('users.continue')}?`,
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: this.$t('users.cancellation'),
          type: "warning",
        }
      )
        .then(() => {
          this.$store.commit("setLoading", true);
          return this.$store.dispatch("deleteUser", currentId);
        })
        .then(() => {
          return this.$store.dispatch("getUserTable");
        })
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
  },
  created() {
    this.$store.commit("setLoading", true);
    this.columnDefs = [
      { headerName: i18n.t("tableHeaders.user.login"), field: "login" },
      { headerName: i18n.t("tableHeaders.user.fullName"), field: "fullName" },
      {
        headerName: i18n.t("tableHeaders.user.datePassword"),
        field: "datepasswd",
        cellClass: "center-column",
      },
      {
        headerName: i18n.t("tableHeaders.user.dateEnd"),
        field: "datebegin",
        cellClass: "center-column",
      },
      {
        headerName: i18n.t("tableHeaders.user.dateBegin"),
        field: "dateend",
        cellClass: "center-column",
      },
      {
        headerName: i18n.t("tableHeaders.user.role"),
        field: "role",
        cellClass: "center-column",
      },
      {
        headerName: i18n.t("tableHeaders.user.status"),
        field: "disable",
        valueGetter: (params) =>
          params.data.disable === '1'
            ? i18n.t("tableHeaders.user.statusDisabled")
            : i18n.t("tableHeaders.user.statusEnabled"),
        cellClass: "center-column",
      },
    ];
    this.$store
      .dispatch("getUserTable")
      .then(() => {
        return this.$store.dispatch("getRoleTable");
      })
      .catch(() => {
        this.$store.commit("setLoading", false);
      });
  },
  computed: {
    ...mapGetters(["getUsersTableArray"]),
  },
  components: {
    myHeader: Header,
    ReferenceGrid,
  },
};
</script>